import _, { isArray } from 'lodash'
import React from 'react'
import { isArrayNullOrEmpty } from '../../utils'
import { buildMultiselectUnidade } from './form-build-multiselect-unidade'
import { formBuildMultiselectTipoContrato } from './form-build-multiselect-tipo-contrato'
import { formBuildMultiselectGrupoFinanceiro } from './form-build-multiselect-grupo-financeiro'
import { formBuildMultiselectFormaPagamento } from './form-build-multiselect-forma-pagamento'
import { formBuildMultiselectContaCorrente } from './form-build-multiselect-conta-corrente'
import { formBuildMultiselectUsuario } from './form-build-multiselect-usuario'
import { formBuildCalendar } from './form-build-calendar'
import { formBuildRadio } from './form-build-radio'
import { normalizeComponentLabel } from './form-builder-utils'
import { formBuildInputText } from './form-build-input-text'
import FormBuildMultiselectProduto from './form-build-multiselect-produto'

export const formBuilder = ({ parametros, record, messages, setField, history }) => {
  if (_.isEmpty(parametros)) {
    return null
  }
  const onChange = (fieldName, value) => {
    if ((isArray(value) && _.isEmpty(value)) || !value) {
      setField(fieldName, '')
    } else {
      setField(fieldName, value)
    }

    if (fieldName === 'oid_unidade') {
      //TODO criar config dependencia
      if (record.hasOwnProperty('oid_tipo_sepultura')) {
        setField('oid_tipo_sepultura', '')
      }
      if (record.hasOwnProperty('oid_grupo_financeiro')) {
        setField('oid_grupo_financeiro', '')
      }
      if (record.hasOwnProperty('oid_produto')) {
        setField('oid_produto', '')
      }
      if (record.hasOwnProperty('oid_usuario')) {
        setField('oid_usuario', '')
      }
      if (record.hasOwnProperty('oid_conta_corrente')) {
        setField('oid_conta_corrente', '')
      }
    }
  }

  const resolveComponent = (componentInfo) => {
    const campo = _.get(componentInfo, 'campo', null)
    const componente = _.get(componentInfo, 'componente', null)
    const label = normalizeComponentLabel(_.get(componentInfo, 'campo', ''))

    // criar Map
    if (campo === 'oid_unidade') {
      if (componente === 'multiselect' || _.isEmpty(componente)) {
        return buildMultiselectUnidade({
          componentInfo,
          messages,
          record,
          onChange,
          label,
        })
      }
    }
    if (campo === 'oid_tipo_sepultura') {
      if (componente === 'multiselect' || _.isEmpty(componente)) {
        return formBuildMultiselectTipoContrato({ componentInfo, messages, record, onChange, label })
      }
    }
    if (campo === 'oid_grupo_financeiro') {
      if (componente === 'multiselect' || _.isEmpty(componente)) {
        return formBuildMultiselectGrupoFinanceiro({ componentInfo, messages, record, onChange, label })
      }
    }
    if (campo === 'oid_forma_pagamento') {
      if (componente === 'multiselect' || _.isEmpty(componente)) {
        return formBuildMultiselectFormaPagamento({ componentInfo, messages, record, onChange, label })
      }
    }
    if (campo === 'oid_conta_corrente') {
      if (componente === 'multiselect' || _.isEmpty(componente)) {
        return formBuildMultiselectContaCorrente({ componentInfo, messages, record, onChange, label })
      }
    }
    if (campo === 'oid_usuario') {
      if (componente === 'multiselect' || _.isEmpty(componente)) {
        return formBuildMultiselectUsuario({ componentInfo, messages, record, onChange, label })
      }
    }
    if (campo === 'oid_produto') {
      if (componente === 'multiselect' || _.isEmpty(componente)) {
        // return formBuildMultiselectProduto({ componentInfo, messages, record, onChange, label })
        return (
          <FormBuildMultiselectProduto
            componentInfo={componentInfo}
            messages={messages}
            record={record}
            onChange={onChange}
            label={label}
          />
        )
      }
    }
    if (_.startsWith(campo, 'dt_')) {
      return formBuildCalendar({ componentInfo, messages, record, onChange, label })
    }
    if (_.startsWith(campo, 'rb_') || componente === 'radio') {
      return formBuildRadio({ componentInfo, messages, record, onChange, label })
    }
    //componente padrao - input text
    return formBuildInputText({ componentInfo, messages, record, onChange, label })
  }

  try {
    const array = JSON.parse(parametros)
    if (isArrayNullOrEmpty(array)) {
      return null
    }

    const notHiddenFields = array.filter((componentInfo) => _.get(componentInfo, 'componente', '') !== 'hidden')
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            {notHiddenFields.map((componentInfo, index) => resolveComponent(componentInfo))}
          </div>
        </div>
      </div>
    )
  } catch (e) {
    return null
  }
}
